import React, { FC, useMemo, useCallback } from "react";
import { WebSocketButton } from "../../store/ChatState";
import "./WsButton.scss";

export interface WsButtonProps {
    button: WebSocketButton;
    onPress: (buttonId: string) => void;
}

const WsButton: FC<WsButtonProps> = ({ button, onPress }) => {
    const handleClick = useCallback(() => {
        if (button.pressBehavior !== "disabled" && !button.isPressed) {
            onPress(button.id);
        }
    }, [button.pressBehavior, button.isPressed, button.id, onPress]);

    const className = useMemo(() => {
        const classes = ["ws-button"];

        if (button.pressBehavior === "disabled" || button.isPressed) {
            classes.push("ws-button--disabled");
        }

        if (button.isPressed && button.pressBehavior === "spinning") {
            classes.push("ws-button--spinning");
        }

        return classes.join(" ");
    }, [button.pressBehavior, button.isPressed]);

    const containerClassName = useMemo(() => {
        const classes = ["ws-button-container"];

        if (button.isDismissing) {
            classes.push("ws-button-container--dismissing");
        }

        return classes.join(" ");
    }, [button.isDismissing]);

    return (
        <div className={containerClassName}>
            <button
                className={className}
                onClick={handleClick}
                disabled={button.pressBehavior === "disabled" || button.isPressed}
                aria-label={button.text}
                aria-busy={button.isPressed && button.pressBehavior === "spinning"}
            >
                {button.isPressed && button.pressBehavior === "spinning" && (
                    <span className="ws-button__spinner" />
                )}
                <span className="ws-button__text">{button.text}</span>
            </button>
        </div>
    );
};

export default WsButton;
